import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaLinkedinIn, FaYoutube, FaRedditAlien } from "react-icons/fa";
import brandLogo from "../../images/dd-logo.png";

const socialLinks = [
  {
    href: "https://www.linkedin.com/company/dark-defensive/",
    label: "Dark Defensive on LinkedIn (opens in a new tab)",
    icon: <FaLinkedinIn />,
  },
  {
    href: "https://www.youtube.com/@DarkDefensive",
    label: "Dark Defensive on YouTube (opens in a new tab)",
    icon: <FaYoutube />,
  },
  {
    href: "https://www.reddit.com/user/darkDefensive",
    label: "Dark Defensive on Reddit (opens in a new tab)",
    icon: <FaRedditAlien />,
  },
];

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const goToSection = (e, id) => {
    e.preventDefault();
    if (location.pathname === "/") {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      navigate("/", { state: { scrollTo: id } });
    }
  };

  return (
    <footer className="dd-footer">
      <div className="dd-footer-inner">
        <div className="dd-footer-connect">
          <Link className="dd-logo" to="/">
            <img
              src={brandLogo}
              alt="Dark Defensive - Detect, Defend, Fortify. Return to the home page."
            />
          </Link>
          <h2>LET&rsquo;S CONNECT</h2>
          <div className="dd-socials">
            {socialLinks.map((s) => (
              <a
                key={s.href}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.label}
              >
                {s.icon}
              </a>
            ))}
          </div>
          <a className="dd-footer-email" href="mailto:info@darkdefensive.com">
            info@darkdefensive.com
          </a>
        </div>

        <nav className="dd-footer-col" aria-label="Product">
          <h2>PRODUCT</h2>
          <ul>
            <li>
              <a href="/#platform" onClick={(e) => goToSection(e, "platform")}>
                Platform
              </a>
            </li>
            <li>
              <a href="/#grc-automation" onClick={(e) => goToSection(e, "grc-automation")}>
                GRC Automation
              </a>
            </li>
            <li>
              <a href="/#frameworks" onClick={(e) => goToSection(e, "frameworks")}>
                Frameworks
              </a>
            </li>
          </ul>
        </nav>

        <nav className="dd-footer-col" aria-label="Company">
          <h2>COMPANY</h2>
          <ul>
            <li><Link to="/about">About</Link></li>
    {/*         <li><Link to="/blog">Blog</Link></li>
            <li><Link to="/case-studies">Case Studies</Link></li> */}
            <li><Link to="/contact-us">Contact</Link></li>
            <li><Link to="/accessibility">Accessibility</Link></li>
            <li><Link to="/privacy-policy">Privacy</Link></li>
          </ul>
        </nav>
      </div>
      <p className="dd-footer-bottom">
        {new Date().getFullYear()} COPYRIGHT Dark Defensive LLC. ALL RIGHTS RESERVED
      </p>
    </footer>
  );
};

export default Footer;
